import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  variant: 'quieter',
  presets: {}
} satisfies RecursivePartial<CMSConfig['megaMenuL2Desktop']>
